import React from 'react';
export function ProblemSection() {
  return <>
      <section className="py-20 relative" data-id="element-217">
        <div className="container mx-auto px-4 max-w-4xl text-center" data-id="element-218">
          <h2 className="font-heading text-3xl md:text-4xl font-bold mb-8 text-white" data-id="element-219">
            La Tragedia Silenciosa Frente al Espejo
          </h2>

          <div className="prose prose-invert prose-lg mx-auto text-gray-400 font-light leading-relaxed" data-id="element-220">
            <p className="mb-6" data-id="element-221">
              Pocas cosas destruyen tanto la confianza como ver el cepillo lleno
              de cabellos cada mañana. O sentir ese pánico sutil al lavar tu
              pelo y ver cómo el desagüe de la ducha se bloquea nuevamente.
            </p>
            <p className="mb-6" data-id="element-222">
              Te miras al espejo bajo esa luz implacable del baño y notas que la
              línea de tu cabello retrocede. Que hay zonas donde el cuero
              cabelludo brilla a través de mechones cada vez más finos.
            </p>
            <p className="mb-10" data-id="element-223">
              <strong className="text-white font-medium" data-id="element-224">
                ¿Y qué has hecho hasta ahora?
              </strong>{' '}
              Probablemente lo mismo que todas. Comprar champús "anti-caída" de
              supermercado que solo lavan dinero, gomitas de biotina que tu
              estómago destruye antes de llegar a la raíz, o peor aún:{' '}
              <span className="text-red-400" data-id="element-225">
                sérums químicos (como el minoxidil) que te hacen esclava de por
                vida
              </span>{' '}
              y causan un efecto rebote devastador si los dejas un solo día.
            </p>

            <div className="p-6 border border-brand-gold/20 rounded-lg bg-brand-card" data-id="element-226">
              <p className="text-xl text-brand-gold font-heading italic" data-id="element-227">
                "El problema no es tu genética. El problema es que la industria
                está tratando los síntomas superficiales, mientras tu folículo
                literalmente muere de asfixia bajo la piel."
              </p>
            </div>
          </div>
        </div>
      </section>

      <div className="section-separator" data-id="element-228"></div>
    </>;
}